

import React from "react";
import json2mq from 'json2mq';
import { useMediaQuery, Avatar } from "@material-ui/core";
import styled from "styled-components";
import { Logo } from "../logo";
import { Accessibility } from "./accessibility";
import { NavLinks } from "./navLinks";
import { DeviceSize } from "../responsive";
import { MobileNavLinks } from "./mobileNavLinks";
import { useStateValue } from "../../StateProvider";

const NavbarContainer = styled.div`
  width: 100%;
  height: 67px;
  box-shadow: 0 1px 3px rgba(15, 15, 15, 0.13);
  display: flex;
  align-items: center;
  padding: 0 1.5em;
  background-color: rgb(240, 240, 240);
  overflow: visible;
  position: relative;

  @media (max-width: ${DeviceSize.mobile}px) {
    padding: 0 1em;
  }
`;

const LeftSection = styled.div`
display: flex;
`;

const MiddleSection = styled.div`
display: flex;
flex: 1;
height: 100%;
justify-content: center;
`;

const RightSection = styled.div`
display: flex;
align-items: center;
gap: 12px;
min-width: fit-content;
`;

const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-end;
  min-width: 0;
`;

const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 20px;
  transition: all 0.2s ease;
  min-width: 0;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.8);
  }

  @media (max-width: ${DeviceSize.mobile}px) {
    padding: 4px 8px;
    gap: 4px;
  }
`;

const UserName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #333;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: ${props => props.isMobile ? 'none' : 'inline-block'};

  @media (max-width: 1024px) {
    max-width: 100px;
  }

  @media (max-width: ${DeviceSize.mobile}px) {
    display: none;
  }
`;

const StyledAvatar = styled(Avatar)`
  width: 32px !important;
  height: 32px !important;
  background: linear-gradient(135deg, #6366f1, #22d3ee);
  font-size: 14px !important;
  font-weight: bold !important;
`;

const SubscriptionBadge = styled.span`
  font-size: 10px;
  font-weight: bold;
  padding: 3px 8px;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;

  ${props => props.tier === 'premium' ? `
    background: linear-gradient(135deg, #ffd700, #ffed4e);
    color: #333;
    box-shadow: 0 2px 6px rgba(255, 215, 0, 0.4);
  ` : `
    background: rgba(150, 150, 150, 0.2);
    color: #666;
    border: 1px solid rgba(150, 150, 150, 0.3);
  `}
`;

export function NavBar(props) {
    const isMobile = useMediaQuery( json2mq({ maxWidth: DeviceSize.mobile}))
    const [{ user, userTier }] = useStateValue();

    return (
        <NavbarContainer>
          <LeftSection>

          {!isMobile && <Accessibility />}
            {isMobile && <MobileNavLinks />}
            <Logo />
          </LeftSection>
          <MiddleSection>{!isMobile && <NavLinks />}</MiddleSection>
          <RightSection>
            {user && !isMobile && (
              <UserInfoContainer>
                <UserSection>
                  <StyledAvatar
                    alt={user?.display_name}
                    src={user?.images?.[0]?.url}
                  >
                    {!user?.images?.[0]?.url && user?.display_name?.[0]?.toUpperCase()}
                  </StyledAvatar>
                  <UserName isMobile={isMobile}>{user?.display_name}</UserName>
                  <SubscriptionBadge tier={userTier}>
                    {userTier === 'premium' ? '👑 Premium' : 'Free'}
                  </SubscriptionBadge>
                </UserSection>
              </UserInfoContainer>
            )}
          </RightSection>
        </NavbarContainer>
      );
    }


 